import { useCallback, useEffect, useRef, useState } from "react";
import { useVariant } from "../context/VariantContext";

export default function Header() {
  const { navItems, logoWebp } = useVariant();
  const [hidden, setHidden] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const lastY = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      if (menuOpen) return;
      const y = window.scrollY;
      setHidden(y > lastY.current && y > 10);
      lastY.current = y;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [menuOpen]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  const toggleMenu = useCallback(() => {
    setMenuOpen((prev) => !prev);
    setHidden(false);
  }, []);

  const handleNavClick = useCallback(() => {
    setMenuOpen(false);
  }, []);

  return (
    <>
      <header
        className={`lp__header${hidden ? " lp__header--hidden" : ""}${menuOpen ? " lp__header--open" : ""}`}
      >
        <img
          className="lp__header-logo"
          src={logoWebp}
          alt="たっぷ"
          width="65"
          height="26"
        />
        <button
          className={`lp__header-menu${menuOpen ? " lp__header-menu--open" : ""}`}
          aria-label={menuOpen ? "メニューを閉じる" : "メニュー"}
          aria-expanded={menuOpen}
          onClick={toggleMenu}
        >
          <span />
          <span />
          <span />
        </button>
      </header>

      <nav className={`lp__nav${menuOpen ? " lp__nav--open" : ""}`}>
        <ul className="lp__nav-list">
          {navItems.map((item) => (
            <li key={item.href} className="lp__nav-item">
              <a href={item.href} className="lp__nav-link" onClick={handleNavClick}>
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
}
